import React from "react";
import { shallowEqual } from "react-redux";
import { useBnbSelector } from "../../../../redux/store";
import { NavStep } from "../../../../../shared-logic/utils/Navigation";
import BasketItems from "./items/BasketItems";
import BasketETA from "./summary/BasketETA";
import PaymentDetails from "../PaymentDetails";
import * as Styles from "./styles/Basket";
import * as Message from "../../../../../../../common-deprecated/styles/v2/lexus/components/Message";
import { IconCart } from "../../../../../../../common-deprecated/styles/v2/lexus/globals/Icon";
import { IconWrapper } from "../../../../../../../common-deprecated/styles/v2/lexus/globals/IconWrapper";
import { useBnbOptionalLabel } from "../../../../utils/labels";
import * as PaymentDetailStyles from "../styles/PaymentDetails";
import BasketMassManagement from "./content/BasketMassManagement";
import ExternalPriceTaxDisclaimer from "../price/ExternalPriceTaxDisclaimer";
import BasketHeader from "./content/BasketHeader";
import TotalPriceDisclaimers from "../price/TotalPriceDisclaimers";
import { enabledServicesSelector } from "../../../../utils/selectorUtils";
import InsuranceDetails from "./content/InsuranceDetails";
import TradeInDetails from "./content/TradeInDetails";
import { showPrice } from "../../../../../../../common-deprecated/settings/utils/financeSettingUtilsCommon";

import { isOnlinePurchaseAvailable } from "../../../../../../shared-logic/utils/basketUtils";

type PropsType = {
    attached?: boolean;
    cashPriceDisclaimer?: string | null;
};

const Basket = (props: PropsType): JSX.Element => {
    const { attached, cashPriceDisclaimer } = props;
    const step = useBnbSelector(({ navigation }) => navigation.step);
    const commonSettings = useBnbSelector((state) => state.commonSettings);
    const { showTradeIn, showInsurance } = useBnbSelector(enabledServicesSelector, shallowEqual);
    const onlinePurchaseNotPossible = useBnbSelector((state) => !isOnlinePurchaseAvailable(state.basket));

    const notOnlineAvailableLabel = useBnbOptionalLabel("notAvailableOnlineBasketWarning");
    const showPrices = showPrice(commonSettings);

    return (
        <Styles.Wrapper attached={attached && showPrices} className="build-basket-wrapper">
            <Styles.Inner>
                <Styles.BasketHeaderWrapper hideOnMobile={step === NavStep.Summary}>
                    <BasketHeader />
                </Styles.BasketHeaderWrapper>

                {step === NavStep.Customize && <BasketItems showVehiclePrice />}
                {showPrices && <ExternalPriceTaxDisclaimer />}
                {showTradeIn && <TradeInDetails />}
                <BasketMassManagement />

                {showPrices && (
                    <>
                        <Styles.PaymentDetailsWrapper>
                            <PaymentDetails cashPriceDisclaimer={cashPriceDisclaimer} />
                        </Styles.PaymentDetailsWrapper>
                    </>
                )}

                {step === NavStep.Summary && <BasketETA />}

                {/* Granularity */}
                {onlinePurchaseNotPossible && notOnlineAvailableLabel && (
                    <Message.Info>
                        <IconWrapper>
                            <IconCart />
                        </IconWrapper>
                        {notOnlineAvailableLabel}
                    </Message.Info>
                )}

                {showInsurance && <InsuranceDetails />}

                <PaymentDetailStyles.DisclaimerWrapper>
                    <TotalPriceDisclaimers />
                </PaymentDetailStyles.DisclaimerWrapper>
            </Styles.Inner>
        </Styles.Wrapper>
    );
};

export default Basket;
